import React from 'react';
import ResendContract from './ResendContract';
import { connect } from 'react-redux';
import { onUserInput } from '../../../../../stores/userInputActions';
import actions from '../../../../../stores/contracting/root-actions-map';
import { doResendContract, updatePartnerForSentDoc as updateRequestPartnerAction } from '../../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import { updatePropsInResendContractReducer } from '../../../../../stores/contracting/dialogs/dialog-constants';

const ResendContractUpdaatePartnerContainer = props => {
  return (
    <ResendContract {...props} />
  );
};

const mapStateToProps = ({ contracting, user }) => ({
  companyType: user.getIn(['user', 'type']),
  ...contracting.resendContractDialog.toJS(),
});

const mapDispatchToProps = dispatch => ({
  closeResendContractDialog: onUserInput(dispatch, actions, 'closeResendContractDialog'),
  dispatchResendContract: (...args) => dispatch(doResendContract(...args)),
  updatePartnerForSentDoc: (...args) => dispatch(updateRequestPartnerAction(...args)),
  onBCCSelfCheck: onUserInput(dispatch, actions, 'onBCCSelfCheck'),
  includeGeneralNoteCheck: onUserInput(dispatch, actions, 'includeGeneralNoteCheck'),
  updateProps: (...args) => dispatch(updatePropsInResendContractReducer(...args)),
  includeMultiLocNotesCheck: onUserInput(dispatch, actions, 'includeMultiLocNotesCheck'),
});
export default connect(mapStateToProps, mapDispatchToProps)(ResendContractUpdaatePartnerContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/dialogs/resend-or-update-dialog.jsx